export class PlayerModel {
    public id: string;
    public guid: string;
    public name: string;
    public type: number = -1;
    public totalScore: number = 0;
    public score: number = 0;
    public time: number = 0;

    public visible: boolean = false;

    public getNameTrimmed(): string {
        let name = this.name.replace(/\r?\n|\r/g, " ");
        let length = 20;
        if (name.length > 20) {
            return name.substring(0, length) + "...";
        }
        return name;
    }

    public getName(): string {
        return this.name.replace(/\r?\n|\r/g, " ");
    }

    public constructor() {
    }
}
